import { render, staticRenderFns } from "./notification_icon.vue?vue&type=template&id=387d0658&scoped=true&"
import script from "./notification_icon.vue?vue&type=script&lang=js&"
export * from "./notification_icon.vue?vue&type=script&lang=js&"
import style0 from "./notification_icon.vue?vue&type=style&index=0&id=387d0658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d0658",
  null
  
)

export default component.exports